import { FIELDS } from '@/pages/Vendorrmas/components/VendorrmaLines/constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 65,
  // },
  {
    key: 'Id',
    field: FIELDS.ID,
    //cell: 'navigation',
    title: 'Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    locked: true,
    width: 60,
  },
  {
    title: 'Part Number',
    field: FIELDS.PART_NUMBER,
  },
  {
    title: 'Ordered',
    field: FIELDS.ORDERED,
  },
  {
    title: 'Returned',
    field: FIELDS.RETURNED,
  },
  {
    title: 'Reason',
    field: FIELDS.RETURN_REASON_NAME,
  },
  {
    title: 'Comment',
    field: FIELDS.COMMENTS,
  },
  {
    title: 'Cost',
    field: FIELDS.COST,
  },
  {
    title: 'Total',
    field: FIELDS.LINE_TOTAL,
  },
  {
    title: 'Description',
    field: FIELDS.DESCRIPTION,
  },
  {
    title: 'Mfr',
    field: FIELDS.MFR,
  },
  {
    title: 'Category',
    field: FIELDS.CATEGORY_NAME,
  },
  {
    title: 'Class',
    field: FIELDS.CLASS_NAME,
  },
  {
    title: 'Date Code',
    field: FIELDS.DATE_CODE,
  },
  {
    title: 'Lot Code',
    field: FIELDS.LOT_CODE,
  },
  {
    title: 'Revision',
    field: FIELDS.REVISION,
  },
  {
    title: 'Condition',
    field: FIELDS.CONDITION,
  },
  {
    title: 'Country Origin',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
  },
  {
    field: 'deletecommands',
    title: '',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: true,
    locked: true,
    width: 30,
  },
];

export default defaultFields;
